module.exports = __webpack_public_path__ + "page-not-found.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-not-found.jpg
// module id = 726
// module chunks = 0